import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { message } from "antd";
import axiosHttp from "services/axiosHttp";

//create action
export const updateNews = createAsyncThunk(
  "updateNews",
  async ({ id, data, form, history }) => {
    const token = localStorage.getItem("auth_token");
    const config = {
      headers: {
        Authorization: `Bearer ${token}`,
        "Access-Control-Allow-Origin": "*",
        "Content-Type": "application/json",
        Accept: "application/json",
      },
    };
    const response = await axiosHttp.patch(
      `news/update?id=${id}`,
      data,
      config
    );

    form.resetFields();
    message.success("News successfully updated!");
    history("/app/news/list");
    return response.data;
  }
);

const newsUpdateSlice = createSlice({
  name: "newsUpdate",
  initialState: {
    isLoading: false,
    error: null,
  },

  extraReducers: (builder) => {
    builder.addCase(updateNews.pending, (state, action) => {
      state.isLoading = true;
    });

    builder.addCase(updateNews.fulfilled, (state, action) => {
      state.isLoading = false;
      state.data = action.payload;
    });
    builder.addCase(updateNews.rejected, (state, action) => {
      state.isLoading = false;
      state.error = action.payload;
    });
  },
});

export default newsUpdateSlice.reducer;
